import { Component, OnInit } from '@angular/core';

import { environment } from 'src/environments/environment';
import { ImageService } from 'src/app/services/image/image.service';
import { Router } from '@angular/router';
import { GenertedLinkedinService } from './services/generted-linkedin.service';
import { GeneratedLinkedinModel } from './model/generated-linkedin-model';

@Component({
  selector: 'app-generatedlinkdin',
  templateUrl: './generatedlinkdin.component.html',
  styleUrls: ['./generatedlinkdin.component.css'],
})
export class GeneratedlinkdinComponent implements OnInit {
  constructor(
    private generatedLinkedinService: GenertedLinkedinService,
    private imageService: ImageService,
    private router: Router
  ) {}

  generatedLinkedins: GeneratedLinkedinModel[] = [];
  linkedinImageUrls: { [key: string]: string } = {};
 
  imagePath = environment.apiUrl 

  ngOnInit(): void {
    this.generatedLinkedinService.getGeneratedLinkedins().subscribe((linkedins: any) => {
      this.generatedLinkedins = linkedins;
      this.loadAllImages();
    });
  }

  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  downloadFile(path: string) {
    const fullUrl = this.imagePath + path;
    const fileName = path.split('/').pop() || 'download';

    this.imageService.getSecureImage(fullUrl).subscribe({
      next: (blobUrl) => {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error: (err) => {
        console.error('Error downloading file:', err);
        alert('Failed to download file. Please try again.');
      },
    });
  }

  makeOrder(linkedinId: string, type: string) {
    this.router.navigate(['/payment'], {
      state: {
        productKey: type,
        serviceSystemId: linkedinId,
      },
      queryParams: {
        productKey: type,
        serviceSystemId: linkedinId,
      },
    });
  }

  loadAllImages() {
    this.generatedLinkedins.forEach((linkedin) => {
      if (linkedin.imagePath) {
        const fullImageUrl = this.imagePath + linkedin.imagePath;

        this.imageService.getSecureImage(fullImageUrl).subscribe({
          next: (blobUrl) => {
            this.linkedinImageUrls[fullImageUrl] = blobUrl;
          },
          error: (err) => {
            console.error('Error loading image:', err);
          },
        });
      }
    });
  }

  getImageUrl(imageLink: string): string {
    const fullImageUrl = this.imagePath + imageLink;
    return this.linkedinImageUrls[fullImageUrl] || 'assets/img/placeholder.png';
  }
}